// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import {
  FacebookAuthProvider, getAuth, GoogleAuthProvider, OAuthProvider,
} from 'firebase/auth';
// Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyBRfDQjQfTd4LDx7K1ELNqoCCUsAHccfdQ',
  authDomain: 'fluttercare.web.app',
  databaseURL: 'https://flutter-app-v1-development-default-rtdb.firebaseio.com',
  projectId: 'flutter-app-v1-development',
  storageBucket: 'flutter-app-v1-development.appspot.com',
  messagingSenderId: '37893439959',
  appId: '1:37893439959:web:2ed3c692e7f529107acb92',
  measurementId: 'G-N2W6P2K4CW',
};

const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();
const appleProvider = new OAuthProvider('apple.com');

export {
  firestore, auth, googleProvider, facebookProvider, appleProvider,
};
